(function () {
  function getScrollY() {
    return (
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function bindScrollListeners(callback) {
    const opts = { passive: true, capture: true };
    [window, document, document.documentElement, document.body].forEach((target) => {
      if (!target || !target.addEventListener) return;
      target.addEventListener("scroll", callback, opts);
    });
    window.addEventListener("resize", callback, { passive: true });
  }

  function initTheme() {
  const navbar = document.getElementById("navbar");
  const scrollHint = document.getElementById("scroll-hint");
  const heroHeadline = document.getElementById("hero-headline");
  const collection = document.getElementById("collection");
  const heroVideo = document.querySelector(".hero__video");
  const COLLAPSE_DISTANCE = 320;
  const SCROLL_HINT_HIDE = 80;
  const isProductPage = document.body.classList.contains("template-product");
  const isInnerPage =
    isProductPage ||
    document.body.classList.contains("template-cart") ||
    document.body.classList.contains("template-collection");

  function themeAssetUrl(filename) {
    if (!window.JTD || !window.JTD.assetSample || !window.JTD.assetSampleName) {
      return filename;
    }
    return window.JTD.assetSample.replace(window.JTD.assetSampleName, filename);
  }

  function updateNavbar() {
    const scrollY = getScrollY();
    const progress = isInnerPage
      ? 1
      : Math.min(1, Math.max(0, scrollY / COLLAPSE_DISTANCE));

    document.documentElement.style.setProperty("--collapse-progress", progress);

    if (navbar) {
      navbar.classList.toggle("navbar--scrolled", isInnerPage || progress > 0.65);
    }

    if (scrollHint) {
      scrollHint.classList.toggle("scroll-hint--hidden", scrollY > SCROLL_HINT_HIDE);
    }

    if (heroHeadline) {
      heroHeadline.classList.toggle("hero-headline--hidden", scrollY > SCROLL_HINT_HIDE);
    }
  }

  bindScrollListeners(updateNavbar);
  updateNavbar();

  document.addEventListener("shopify:section:load", updateNavbar);
  document.addEventListener("shopify:section:unload", updateNavbar);

  if (heroVideo) {
    heroVideo.addEventListener("error", () => {
      const sources = heroVideo.querySelectorAll("source");
      const nextIndex = Number(heroVideo.dataset.sourceIndex || 0) + 1;
      if (nextIndex < sources.length) {
        heroVideo.dataset.sourceIndex = nextIndex;
        heroVideo.src = sources[nextIndex].src;
        heroVideo.load();
        heroVideo.play().catch(() => {});
      }
    });

    heroVideo.play().catch(() => {});
  }

  if (scrollHint && collection) {
    scrollHint.addEventListener("click", () => {
      collection.scrollIntoView({ behavior: "smooth" });
    });
  }

  const variantCards = document.querySelectorAll(".product-card--variants");

  variantCards.forEach((card) => {
    const defaultImg = card.querySelector(".product-card__img--default");
    const hoverImg = card.querySelector(".product-card__img--hover");
    const swatches = card.querySelectorAll(".product-card__swatch");
    const cartBtn = card.querySelector("[data-add-to-cart]");

    swatches.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        if (swatch.classList.contains("is-active")) return;

        swatches.forEach((btn) => {
          btn.classList.remove("is-active");
          btn.setAttribute("aria-pressed", "false");
        });

        swatch.classList.add("is-active");
        swatch.setAttribute("aria-pressed", "true");

        if (defaultImg && swatch.dataset.tilt) defaultImg.src = swatch.dataset.tilt;
        if (hoverImg && swatch.dataset.front) hoverImg.src = swatch.dataset.front;
        if (cartBtn && swatch.dataset.variantId) {
          cartBtn.dataset.variantId = swatch.dataset.variantId;
        }
      });
    });
  });

  async function updateCartCount() {
    const countEl = document.querySelector("[data-cart-count]");
    if (!countEl) return;

    try {
      const response = await fetch("/cart.js");
      if (!response.ok) return;
      const cart = await response.json();
      countEl.textContent = cart.item_count;
    } catch {
      /* ignore */
    }
  }

  async function addToCart(variantId, button) {
    if (!variantId || !button || button.disabled) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = "Adding…";

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
        }),
      });

      if (!response.ok) {
        throw new Error("Add to cart failed");
      }

      button.textContent = "Added!";
      await updateCartCount();
      window.setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1200);
    } catch {
      button.textContent = "Try again";
      button.disabled = false;
      window.setTimeout(() => {
        button.textContent = originalText;
      }, 1200);
    }
  }

  document.querySelectorAll("[data-add-to-cart]").forEach((button) => {
    button.addEventListener("click", () => {
      addToCart(button.dataset.variantId, button);
    });
  });

  const COLLECTION_ROTATE_MS = 4200;
  const CRT_TRANSITION_MS = 800;

  function cloneSlideContent(source, targetLayer) {
    targetLayer.innerHTML = "";
    if (source.tagName === "IMG") {
      const img = document.createElement("img");
      img.src = source.currentSrc || source.src;
      img.alt = source.alt;
      targetLayer.appendChild(img);
    } else {
      const clone = source.cloneNode(true);
      targetLayer.appendChild(clone);
    }
  }

  function advanceSlideShow(container, prefix) {
    const sources = container.querySelectorAll(`.${prefix}__sources > *`);
    if (sources.length <= 1) return;

    const screen = container.querySelector(`.${prefix}__screen`);
    const currentLayer = container.querySelector(`.${prefix}__layer--current`);
    const nextLayer = container.querySelector(`.${prefix}__layer--next`);
    if (!screen || !currentLayer || !nextLayer || screen.classList.contains("is-changing")) {
      return;
    }

    const currentIndex = Number(container.dataset.slideIndex || 0);
    const nextIndex = (currentIndex + 1) % sources.length;
    const nextSource = sources[nextIndex];

    cloneSlideContent(nextSource, nextLayer);
    screen.classList.add("is-changing");

    window.setTimeout(() => {
      cloneSlideContent(nextSource, currentLayer);
      nextLayer.innerHTML = "";
      nextLayer.style.removeProperty("clip-path");
      container.dataset.slideIndex = String(nextIndex);
      screen.classList.remove("is-changing");
    }, CRT_TRANSITION_MS);
  }

  function initNewDropTv() {
    const newDropTv = document.querySelector(".new-drop__tv");
    if (!newDropTv) return;

    newDropTv.dataset.slideIndex = "0";
    const sources = newDropTv.querySelectorAll(".new-drop__sources > *");
    if (sources.length <= 1) return;

    window.setInterval(() => advanceSlideShow(newDropTv, "new-drop"), COLLECTION_ROTATE_MS);
  }

  function initNewDropWidget() {
    const newDrop = document.getElementById("new-drop");
    const newDropTv = document.querySelector(".new-drop__tv");
    const sourcesContainer = document.querySelector(".new-drop__sources");
    const currentLayer = document.querySelector(".new-drop__layer--current");

    if (!newDrop || !newDropTv || !sourcesContainer || !currentLayer) return;

    const sources = sourcesContainer.querySelectorAll("img");
    if (!sources.length) return;

    if (!currentLayer.querySelector("img") && sources[0]) {
      currentLayer.appendChild(sources[0].cloneNode(true));
    }

    initNewDropTv();
  }

  initNewDropWidget();

  const dropstopVideo = document.querySelector(".dropstop__video");
  const dropstopMuteBtn = document.querySelector(".dropstop__mute-btn");
  const DROPSTOP_VOLUME = 0.5;

  function setDropstopVolume() {
    if (!dropstopVideo) return;
    dropstopVideo.volume = DROPSTOP_VOLUME;
  }

  function updateDropstopMuteBtn() {
    if (!dropstopVideo || !dropstopMuteBtn) return;
    const muted = dropstopVideo.muted;
    dropstopMuteBtn.classList.toggle("dropstop__mute-btn--muted", muted);
    dropstopMuteBtn.setAttribute("aria-pressed", muted ? "true" : "false");
    dropstopMuteBtn.setAttribute("aria-label", muted ? "Unmute video" : "Mute video");
  }

  async function playDropstopVideo() {
    if (!dropstopVideo) return;
    setDropstopVolume();
    dropstopVideo.muted = false;
    updateDropstopMuteBtn();
    try {
      await dropstopVideo.play();
    } catch {
      dropstopVideo.muted = true;
      updateDropstopMuteBtn();
      dropstopVideo.play().catch(() => {});
    }
  }

  if (dropstopVideo) {
    setDropstopVolume();
    dropstopVideo.muted = false;
    updateDropstopMuteBtn();

    dropstopVideo.addEventListener("volumechange", () => {
      if (!dropstopVideo.muted && dropstopVideo.volume !== DROPSTOP_VOLUME) {
        setDropstopVolume();
      }
    });

    const dropstopObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playDropstopVideo();
          } else {
            dropstopVideo.pause();
          }
        });
      },
      { threshold: 0.35 }
    );

    dropstopObserver.observe(dropstopVideo);
  }

  if (dropstopMuteBtn && dropstopVideo) {
    dropstopMuteBtn.addEventListener("click", async () => {
      if (dropstopVideo.muted) {
        setDropstopVolume();
        dropstopVideo.muted = false;
        updateDropstopMuteBtn();
        try {
          await dropstopVideo.play();
        } catch {
          dropstopVideo.muted = true;
          updateDropstopMuteBtn();
        }
      } else {
        dropstopVideo.muted = true;
        updateDropstopMuteBtn();
      }
    });
  }

  const newDrop = document.getElementById("new-drop");
  const newDropClose = document.querySelector(".new-drop__close");

  if (newDropClose && newDrop) {
    newDropClose.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      newDrop.hidden = true;
    });
  }

  function formatMoney(cents) {
    const format = window.JTD?.moneyFormat || "${{amount}}";
    const amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function initProductGallery() {
    const gallery = document.querySelector("[data-product-gallery]");
    if (!gallery) return;

    const track = gallery.querySelector("[data-gallery-track]");
    const slides = gallery.querySelectorAll("[data-gallery-slide]");
    const prevBtn = gallery.querySelector("[data-gallery-prev]");
    const nextBtn = gallery.querySelector("[data-gallery-next]");
    const dots = gallery.querySelectorAll("[data-gallery-dot]");

    if (!track || slides.length <= 1) return;

    let currentIndex = 0;
    let touchStartX = 0;
    let touchDeltaX = 0;

    function goTo(index) {
      currentIndex = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${currentIndex * 100}%)`;

      dots.forEach((dot, i) => {
        dot.classList.toggle("is-active", i === currentIndex);
      });
    }

    function handleTouchStart(event) {
      touchStartX = event.changedTouches[0].screenX;
      touchDeltaX = 0;
    }

    function handleTouchMove(event) {
      touchDeltaX = event.changedTouches[0].screenX - touchStartX;
    }

    function handleTouchEnd() {
      if (Math.abs(touchDeltaX) < 40) return;
      goTo(currentIndex + (touchDeltaX < 0 ? 1 : -1));
    }

    prevBtn?.addEventListener("click", () => goTo(currentIndex - 1));
    nextBtn?.addEventListener("click", () => goTo(currentIndex + 1));

    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        goTo(Number(dot.dataset.galleryDot || 0));
      });
    });

    gallery.addEventListener("touchstart", handleTouchStart, { passive: true });
    gallery.addEventListener("touchmove", handleTouchMove, { passive: true });
    gallery.addEventListener("touchend", handleTouchEnd, { passive: true });
  }

  function initProductPage() {
    const productPage = document.getElementById("product-page");
    if (!productPage) return;

    initProductGallery();

    const variantSelect = productPage.querySelector("[data-variant-select]");
    const priceEl = productPage.querySelector("[data-product-price]");
    const variantsJson = productPage.querySelector("[data-product-variants]");

    if (!variantSelect || !priceEl || !variantsJson) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsJson.textContent || "[]");
    } catch {
      return;
    }

    variantSelect.addEventListener("change", () => {
      const variant = variants.find((item) => String(item.id) === variantSelect.value);
      if (variant) {
        priceEl.textContent = formatMoney(variant.price);
      }
    });
  }

  initProductPage();

  document.querySelectorAll("[data-back-link]").forEach((backLink) => {
    backLink.addEventListener("click", (event) => {
      if (window.history.length > 1 && document.referrer.includes(window.location.host)) {
        event.preventDefault();
        window.history.back();
      }
    });
  });

  updateCartCount();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTheme);
  } else {
    initTheme();
  }
})();
